// React
import React, { useMemo, memo } from 'react'
import PropTypes from 'prop-types'

// Components
import BTime from 'ui/blocks/TimeButton'

export const Button = memo((props) => {
  const availability = useMemo(() => {
    if (props.availabilityMode === 'timeslots') {
      return props.availabilities?.find((el) => el.value === props.field.value)
    }

    return props.availabilities?.toList?.().find((el) => `${el.hour}:${el.minute}` === props.data.value)
  }, [props.availabilities, props.availabilityMode, props.field, props.data.value])

  const size = () => (props.availabilities?.size ? props.availabilities?.size() : props.availabilities?.length)

  const handleSelect = (e) => {
    e.preventDefault()

    props.onSelect(props.data.value)
  }

  return (
    <BTime.Timeslot
      isActive={props.data.value === props.field.value}
      onClick={handleSelect}
      type="button"
      data-value={props.data.value}
      data-label={props.label}
    >
      {size() > 0 && props.showAvailability && (
        <BTime.AvailabilityIndicator status={availability?.status} className={availability?.status} />
      )}
      {props.label}
    </BTime.Timeslot>
  )
})

Button.displayName = 'TimeButton'

Button.propTypes = {
  data: PropTypes.object,
  field: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onInvalid: PropTypes.func,
    /** Custom validation function should return invalid key or true
     * ex. validate = (date) => 'HH'
     */
    validate: PropTypes.func
  }),
  onSelect: PropTypes.func,
  showAvailability: PropTypes.oneOf([true, false, 'count']),
  availabilities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  availabilityMode: PropTypes.string,
  label: PropTypes.any
}
